// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overallTagsContainer{
    .css-1ggoop8 svg {
        font-size: 27px;
        cursor: pointer;
        padding: 4px;
    }
}
.MuiSvgIcon-root {
    font-size: 27px;
    cursor: pointer;
    padding: 4px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/tags.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;AACJ;AACA;IACI,eAAe;IACf,eAAe;IACf,YAAY;AAChB","sourcesContent":[".overallTagsContainer{\n    .css-1ggoop8 svg {\n        font-size: 27px;\n        cursor: pointer;\n        padding: 4px;\n    }\n}\n.MuiSvgIcon-root {\n    font-size: 27px;\n    cursor: pointer;\n    padding: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
